import { deleteApi, get, post } from "../GenericServices";

const ClientPortal = {
  getListClient: (queryString) => {
    return get(`client-portal?${queryString}`);
  },
  clientRemove: (id) => {
    return deleteApi(`client-portal/${id}`);
  },
  saveClient: (data) => {
    return post(`client-portal`, data);
  },
  getClients: (id) => {
    return get(`client-portal/${id}`);
  },
};

export default ClientPortal;
